import React from "react";
import Dialog from "./Dialog";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import useResetForm from "../hooks/custom/useResetForm";
import Input from "./Input";
import Options from "./Options";
import AddButton from "./AddButton";

export default function FormAddDiskonBersaudara(props) {
  const method = useForm({
    mode: "all",
    resolver: yupResolver(
      yup.object().shape({
        diskon: yup
          .number()
          .typeError("Tidak boleh kosong")
          .required("Tidak boleh kosong"),
        tahun_ajar: yup.string().required("TIdak boleh koson"),
      })
    ),
  });
  useResetForm(method, { diskon: 0, tahun_ajar: "" }, props.show);
  return (
    <Dialog show={props.show} toggle={props.close}>
      <div className="bg-white md:w-[40vw] w-[95vw]">
        <div className="py-4 px-6 border-b border-slate-200">
          <h1 className="text-xl">Tambah Diskon Bersaudara</h1>
        </div>
        <form
          onSubmit={method.handleSubmit(props.submit)}
          className="px-6 py-7 space-y-1"
        >
          <div className="flex space-x-2">
            <Input
              label="Diskon"
              type="number"
              method={method}
              methodName="diskon"
            />
            <Options
              label="Tahun Ajar"
              method={method}
              methodName="tahun_ajar"
              options={props.tahunOptions}
            />
          </div>
          <AddButton />
        </form>
      </div>
    </Dialog>
  );
}
